<!-- Default Navbar -->
<nav
    class="navbar-area navbar navbar-expand-lg bg-light"
    ngStickyNav
    stickyClass="sticky-box-shadow"
    [class.active]="classApplied"
>
    <div class="container">
        <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#leftMenu" aria-controls="leftMenu">
            <span class="burger-menu">
                <!-- <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span> -->
                <img src="/assets/images/svg/icon_mobile_drawer.svg" alt="Menu" title="Menu" />
            </span>
        </button>
        <a
            class="navbar-brand d-none"
            href="{{getLinkUrlById('website')}}"
            [target]="getLinkTarget('website')"
            [ngClass]="{'d-inline-block': true}"
        >
            <img class="logo-img d-none d-lg-block" onerror="this.onerror=null" [src]="logo">
            <img class="logo-img d-block d-lg-none" onerror="this.onerror=null" [src]="logoMobile">
        </a>
        
        <div *ngIf="classApplied" class="others-options ms-auto">
            <a *ngIf="!isLoggedIn() && loginSupported()" class="login d-none d-sm-inline-block" (click)="login.open()">
                Log In
            </a>
            <a *ngIf="!isLoggedIn() && settings.style.header.signUpButton && settings.style.header.signUpButton.show" href="{{settings.style.header.signUpButton.url}}" class="btn btn-primary signUpButton">
                {{settings.style.header.signUpButton.text}}
            </a>
            <a *ngIf="isLoggedIn()" class="btn btn-link account-btn" href="/account">
                <img *ngIf="avatar().length != 2" [src]="avatar()" class="rounded-circle" alt="account">
                <div *ngIf="avatar().length == 2" class="avatar rounded-circle" alt="account">{{avatar()}}</div>
            </a>
        </div>

        <div
            class="collapse navbar-collapse"
            [ngClass]="{'nav-center': true}"
        >
            <ul class="navbar-nav">
                <ng-container *ngFor="let link of navbarLeftLinks">
                    <li class="nav-item" *ngIf="link.url">
                        <a class="nav-link" [class.active]="isActiveLink(link.url)" [href]="link.url" [attr.target]="link.target ? link.target : null">{{ link.name }}</a>
                    </li>
                </ng-container>
                <li *ngIf="!isLoggedIn() && loginSupported()" class="nav-item d-block d-sm-none">
                    <a class="nav-link" (click)="login.open()">Log In</a>
                </li>
            </ul>
        </div>
        <div *ngIf="!classApplied" class="others-options ms-auto">
            <a *ngIf="!isLoggedIn() && loginSupported()" class="login d-none d-sm-inline-block" (click)="login.open()">
                Log In
            </a>
            <a *ngIf="!isLoggedIn() && settings.style.header.signUpButton && settings.style.header.signUpButton.show" href="{{settings.style.header.signUpButton.url}}" class="btn btn-primary signUpButton">
                {{settings.style.header.signUpButton.text}}
            </a>
            <ul *ngIf="avatar()" class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="btn btn-secondary-outline account-btn account-btn-mobile" data-bs-toggle="offcanvas" data-bs-target="#rightMenu" aria-controls="rightMenu" href="#">
                        <img *ngIf="avatar().length != 2" [src]="avatar()"  class="rounded-circle">
                        <div *ngIf="avatar().length == 2" class="avatar rounded-circle" alt="account">{{avatar()}}</div>
                    </a>
                    <a class="btn btn-secondary-outline account-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" href="#">
                        <!-- <img [src]="avatar()" alt="account" (mouseover)="showMenu($event, 'acct')" (mouseout)="showMenu($event, 'acct')"> -->
                        <img *ngIf="avatar().length != 2" [src]="avatar()" class="rounded-circle" alt="account" (mouseover)="showMenu($event, 'acct')" (mouseout)="showMenu($event, 'acct')">
                        <div *ngIf="avatar().length == 2" class="avatar rounded-circle" alt="account" (mouseover)="showMenu($event, 'acct')" (mouseout)="showMenu($event, 'acct')">{{avatar()}}</div>
                    </a>
                    <ul class="dropdown-menu acct-dropdown" [ngClass]="menuClass('acct')" (mouseover)="showMenu($event, 'acct')" (mouseout)="showMenu($event, 'acct')">
                        <li><a class="dropdown-item nav-link" href="/account">Account</a></li>
                        <li><a class="dropdown-item nav-link" href="#" (click)="logout()">Log Out</a></li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>

<div class="offcanvas offcanvas-start w-75" data-bs-scroll="true" tabindex="-1" id="leftMenu" aria-labelledby="leftMenuLabel">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel"></h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body p-0">
        <ul class="navbar-nav">
            <li class="nav-item" *ngFor="let item of mobileMenuLinks; trackBy: trackByMobileMenuItemId">
                <a class="side-nav nav-link" [class.active]="isActiveLink(item.url)" [href]="item.url" [attr.target]="item.target">{{ item.name }}</a>
            </li>
            <!-- <li class="side-nav nav-item">
                <div [class]="collapseHeaderClasses()" data-bs-toggle="collapse" data-bs-target="#subClassesMenu" aria-expanded="true" aria-controls="subClassesMenu">
                    Classes
                </div>
                <div class="collapse show" id="subClassesMenu" (hide.bs.collapse)="collapsing()" (show.bs.collapse)="showing()">
                    <a class="side-sub-nav nav-link" href="/class-schedule">Class Schedule</a>
                    <a class="side-sub-nav nav-link" href="/studios">Studios</a>
                    <a class="side-sub-nav nav-link" href="/instructors">Instructors</a>
                </div>
            </li> -->
            <li class="side-nav">
                <div class="container p-0">
                    <div class="row">
                        <div class="col-6" *ngIf="loginSupported()">
                            <a *ngIf="!isLoggedIn()" class="side-sub-nav nav-link" (click)="login.open()" data-bs-toggle="offcanvas" data-bs-target="#leftMenu" aria-controls="leftMenu">Log In</a>
                            <a *ngIf="isLoggedIn()" class="side-sub-nav nav-link" (click)="logout()" href="/">Log Out</a>
                        </div>
                        <div class="col-6">
                            <a class="side-sub-nav nav-link" href="{{getLinkUrlById('privacyPolicy')}}" [target]="getLinkTarget('privacyPolicy')">Privacy Policy</a>
                        </div>
                        <div class="col-6">
                            <a class="side-sub-nav nav-link" href="{{getLinkUrlById('termsOfUse')}}" [target]="getLinkTarget('termsOfUse')">Terms & Conditions</a>
                        </div>
                        <div class="col-6">
                            <a class="side-sub-nav nav-link" href="{{getLinkUrlById('faq')}}" [target]="getLinkTarget('faq')">FAQ</a>
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div class="container text-center">
                    <div class="row pt-4">
                        <div *ngIf="getLinkUrlById('instagram') != ''" class="col">
                            <a href="{{getLinkUrlById('instagram')}}" target="{{getLinkTarget('instagram')}}">
                                <i class="fa-brands fa-instagram"style="font-size:24px"></i>
                            </a>
                        </div>
                        <div *ngIf="getLinkUrlById('facebook') != ''" class="col">
                            <a href="{{getLinkUrlById('facebook')}}" target="{{getLinkTarget('facebook')}}">
                                <i class="fa-brands fa-facebook-f"style="font-size:24px"></i>
                            </a>
                        </div>
                        <div *ngIf="getLinkUrlById('tiktok') != ''" class="col">
                            <a href="{{getLinkUrlById('tiktok')}}" target="{{getLinkTarget('tiktok')}}">
                                <i class="fa-brands fa-tiktok"style="font-size:24px"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>

<div class="offcanvas offcanvas-end w-75" data-bs-scroll="true" tabindex="-1" id="rightMenu" aria-labelledby="rightMenuLabel">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel"></h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body p-0">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="side-nav nav-link" href="/account">Account</a>
            </li>
            <li class="nav-item">
                <a class="side-nav nav-link" (click)="logout()" href="/">Log Out</a>
            </li>
        </ul>
    </div>
</div>

<df-login #login [title]="loginTitle" [loginText]="loginDescription" (loggedIn)="loggedIn($event)"></df-login>

<div class="navbar-height">&nbsp;</div>